import { EmptyState, FormBlock } from '@westhetics/ui'
import { useState } from 'react'
import { ListFooter } from '@/app/list-footer'
import { LoadError } from '@/app/load-error'
import { useUserSessions } from './api'
import { SessionList, SessionListSkeleton } from './session-list'

/**
 * O bloco "Acessos" da edição do usuário (RN-AUT-25, P-AUT-28): os últimos acessos da conta, para a
 * gestora saber quando e de onde a pessoa entrou. Sem IP (a API já o omite, P-AUT-16) e sem dizer
 * se o acesso abriu esta ou outra clínica (RN-AUT-17). Só leitura: bloquear o vínculo é o que
 * encerra as sessões (RN-AUT-12).
 */
export function UserSessionsBlock({ userId, name }: { userId: string; name: string }) {
  const [page, setPage] = useState(1)
  const sessions = useUserSessions(userId, page)
  const items = sessions.data?.data ?? []

  return (
    <FormBlock
      title="Acessos"
      note="Quando e de qual dispositivo esta conta entrou. O endereço IP fica com a própria pessoa."
    >
      <div className="mt-4">
        {sessions.isError ? (
          <LoadError
            title="Não conseguimos carregar os acessos"
            error={sessions.error}
            onRetry={() => void sessions.refetch()}
          />
        ) : sessions.isPending ? (
          <SessionListSkeleton rows={2} />
        ) : items.length === 0 ? (
          <EmptyState
            title="Nenhum acesso registrado"
            description={`${name} ainda não entrou desde que o vínculo foi criado.`}
          />
        ) : (
          <>
            <SessionList sessions={items} />
            {sessions.data ? (
              <ListFooter
                meta={sessions.data.meta}
                noun={['acesso', 'acessos']}
                note="do mais recente para o mais antigo"
                onPage={setPage}
              />
            ) : null}
          </>
        )}
      </div>
    </FormBlock>
  )
}
